import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [
  {
    path: "",
    title: "",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    submenu: [],
  },

  // Admin Modules
  {
    path: "/admin/dashboard/main",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  {
    path: "",
    title: "Manage Doctors",
    moduleName: "Doctors",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },

  // Doctor Modules
  {
    path: "/doctor/dashboard",
    title: "DASHBOARD",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },
  {
    path: "/doctor/prescription",
    title: "MY PRESCRIPTIONS",
    moduleName: "prescription",
    iconType: "material-icons-two-tone",
    icon: "note_add",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },
  {
    path: "/doctor/patient",
    title: "MY PATIENTS",
    moduleName: "patient",
    iconType: "material-icons-two-tone",
    icon: "people_outline",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },
  {
    path: "/doctor/drug",
    title: "DRUGS",
    moduleName: "drug",
    iconType: "material-icons-two-tone",
    icon: "pie_chart",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },

  // Patient Modules
  {
    path: "/patient/dashboard",
    title: "MENUITEMS.HOME.LIST.PATIENT-DASHBOARD",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },

  // Pharmacist Modules

  {
    path: "/pharmacist/dashboard",
    title: "DASHBOARD",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Pharmacist", "PharmacySubAdmin"],
    submenu: [],
  },
  {
    path: "/pharmacist/prescription",
    title: "PRESCRIPTIONS",
    moduleName: "prescription",
    iconType: "material-icons-two-tone",
    icon: "note_add",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Pharmacist", "PharmacySubAdmin"],
    submenu: [],
  },
  {
    path: "pharmacist/doctor",
    title: "DOCTORS",
    moduleName: "doctor",
    iconType: "material-icons-two-tone",
    icon: "supervised_user_circle",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Pharmacist", "PharmacySubAdmin"],
    submenu: [],
  },
  {
    path: "pharmacist/user",
    title: "MANAGE USERS",
    moduleName: "user",
    iconType: "material-icons-two-tone",
    icon: "people",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Pharmacist"],
    submenu: [],
  },
  {
    path: "/pharmacist/drug",
    title: "DRUGS",
    moduleName: "drug",
    iconType: "material-icons-two-tone",
    icon: "pie_chart",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Pharmacist", "PharmacySubAdmin"],
    submenu: [],
  },
  {
    path: "/pharmacist/SIGCodes",
    title: "SIG Codes",
    moduleName: "SIGCodes",
    iconType: "material-icons-two-tone",
    icon: "shield",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Pharmacist"],
    submenu: [],
  },
  {
    path: "/waiting-room/prescriptions",
    title: "WAITING ROOM",
    moduleName: "patientwaitingroom",
    iconType: "material-icons-two-tone",
    icon: "airline_seat_legroom_normal",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Pharmacist", "PharmacySubAdmin"],
    submenu: [],
  },
  {
    path: "/pharmacist/reports/prescription-Report",
    title: "REPORTS",
    moduleName: "reports",
    iconType: "material-icons-two-tone",
    icon: "insert_chart",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Pharmacist"],
    submenu: [
      {
        path: "/pharmacist/reports/prescription-Report",
        title: "Prescription Report",
        moduleName: "prescription-Report",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/pharmacist/reports/drug-report",
        title: "Drug Report",
        moduleName: "drug-report",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/pharmacist/reports/activity-report",
        title: "Activity log",
        moduleName: "activity-report",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
    ],
  },
];
